/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Gender_LabelInputs */

const th_team_gender_label = /** @type {(inputs: Team_Gender_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ประเภท`)
};

const en_team_gender_label = /** @type {(inputs: Team_Gender_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Category`)
};

const ja_team_gender_label = /** @type {(inputs: Team_Gender_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`区分`)
};

const zh_team_gender_label = /** @type {(inputs: Team_Gender_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`组别`)
};

const es_team_gender_label = /** @type {(inputs: Team_Gender_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categoría`)
};

const pt_team_gender_label = /** @type {(inputs: Team_Gender_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categoria`)
};

const id_team_gender_label = /** @type {(inputs: Team_Gender_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kelas`)
};

const fr_team_gender_label = /** @type {(inputs: Team_Gender_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catégorie`)
};

const tl_team_gender_label = /** @type {(inputs: Team_Gender_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uri`)
};

const vi_team_gender_label = /** @type {(inputs: Team_Gender_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hạng`)
};

const ko_team_gender_label = /** @type {(inputs: Team_Gender_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`부`)
};

const de_team_gender_label = /** @type {(inputs: Team_Gender_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klasse`)
};

const ru_team_gender_label = /** @type {(inputs: Team_Gender_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Категория`)
};

const tr_team_gender_label = /** @type {(inputs: Team_Gender_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kategori`)
};

const it_team_gender_label = /** @type {(inputs: Team_Gender_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categoria`)
};

const pl_team_gender_label = /** @type {(inputs: Team_Gender_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kategoria`)
};

const uk_team_gender_label = /** @type {(inputs: Team_Gender_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Категорія`)
};

const hi_team_gender_label = /** @type {(inputs: Team_Gender_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`श्रेणी`)
};

const ar_team_gender_label = /** @type {(inputs: Team_Gender_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الفئة`)
};

const ms_team_gender_label = /** @type {(inputs: Team_Gender_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kelas`)
};

const bn_team_gender_label = /** @type {(inputs: Team_Gender_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`শ্রেণি`)
};

const zh_tw2_team_gender_label = /** @type {(inputs: Team_Gender_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`組別`)
};

const zh_hk2_team_gender_label = /** @type {(inputs: Team_Gender_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`組別`)
};

const ur_team_gender_label = /** @type {(inputs: Team_Gender_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`درجہ`)
};

const fa_team_gender_label = /** @type {(inputs: Team_Gender_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رده`)
};

const sw_team_gender_label = /** @type {(inputs: Team_Gender_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daraja`)
};

const nl_team_gender_label = /** @type {(inputs: Team_Gender_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categorie`)
};

/**
* | output |
* | --- |
* | "Category" |
*
* @param {Team_Gender_LabelInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const team_gender_label = /** @type {((inputs?: Team_Gender_LabelInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Gender_LabelInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_team_gender_label(inputs)
	if (locale === "ja") return ja_team_gender_label(inputs)
	if (locale === "zh") return zh_team_gender_label(inputs)
	if (locale === "es") return es_team_gender_label(inputs)
	if (locale === "pt") return pt_team_gender_label(inputs)
	if (locale === "id") return id_team_gender_label(inputs)
	if (locale === "fr") return fr_team_gender_label(inputs)
	if (locale === "tl") return tl_team_gender_label(inputs)
	if (locale === "vi") return vi_team_gender_label(inputs)
	if (locale === "ko") return ko_team_gender_label(inputs)
	if (locale === "de") return de_team_gender_label(inputs)
	if (locale === "ru") return ru_team_gender_label(inputs)
	if (locale === "tr") return tr_team_gender_label(inputs)
	if (locale === "it") return it_team_gender_label(inputs)
	if (locale === "pl") return pl_team_gender_label(inputs)
	if (locale === "uk") return uk_team_gender_label(inputs)
	if (locale === "hi") return hi_team_gender_label(inputs)
	if (locale === "ar") return ar_team_gender_label(inputs)
	if (locale === "ms") return ms_team_gender_label(inputs)
	if (locale === "bn") return bn_team_gender_label(inputs)
	if (locale === "zh-TW") return zh_tw2_team_gender_label(inputs)
	if (locale === "zh-HK") return zh_hk2_team_gender_label(inputs)
	if (locale === "ur") return ur_team_gender_label(inputs)
	if (locale === "fa") return fa_team_gender_label(inputs)
	if (locale === "sw") return sw_team_gender_label(inputs)
	if (locale === "nl") return nl_team_gender_label(inputs)
	return en_team_gender_label(inputs)
});